import { useConfiguration } from "../../hooks/useConfiguration";
import { SiteType, TeamContext } from "../../types/common";
import { CalendarCarouselWidget } from "../../widgets/mainScreen/CalendarCarousel";
import { LeagueBannerWidget } from "../../widgets/mainScreen/LeagueBanner";
import { MainScreenStatsWigdet } from "../../widgets/mainScreen/MainScreenStats";
import { FeaturedNewsWidget } from "../../widgets/mainScreen/FeatureNews";
import { setDocumentTitle } from "../../utils";
import { LatestNewsWidget } from "../../widgets/news/LatestNews";

export const HomePage = () => {
    //const path = window.location.pathname;

    const config = useConfiguration();

    let seasonId = config.seasonId;
    if (config.teamName === TeamContext.RODINA || config.teamName === TeamContext.RODINA_2) {
        seasonId = 20;
    } else if (config.teamName === TeamContext.ACADEMY) {
        seasonId = 18;
    } else if (config.teamName === TeamContext.RODINA_M) {
        seasonId = 18;
    }

    let statsFilters = config.mainScreenConfig?.filters;
    if (!statsFilters?.length) {
        statsFilters = [{
            tournamentId: config.tournamentId || 178,
            seasonId: config.seasonId || 18,
            teamId: config.teamId,
        }]
    }

    setDocumentTitle(`Официальный сайт ${config.site === SiteType.LEGACY_ACADEMY ? "Академия" : "ФК"} «Родина»`);

    return (
        <div className="flex flex-col p-2 pt-3 sm:p-0 gap-2" key={config.teamName}>
            <FeaturedNewsWidget teamContext={config.teamName} />
            <LeagueBannerWidget teamName={config.teamName} />
            <CalendarCarouselWidget
                seasonId={seasonId}
                teamId={config.teamId}
                teamName={config.teamName}
            />
            <MainScreenStatsWigdet
                statsFilters={statsFilters}
                topTeams={config.mainScreenConfig?.table.topTeams || 3}
                bottomTeams={config.mainScreenConfig?.table?.bottomTeams || 2}
                prevMatches={config.mainScreenConfig?.matches?.prevMatches || 2}
                teamName={config.teamName}
            />
            <div className="p-2 w-full">
                <LatestNewsWidget title="Новости" actionTitle="Все"/>
            </div>
        </div>
    );
}